import { RequestService } from '../services';

export const commonActions = {
    getInscriptionApiKey
};

function getInscriptionApiKey() {
    return RequestService.GetRequest(`insc-api-key`, true);
}
